exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lean-project-textarea .santd-input {\n  border: none !important;\n  padding: 0 8px !important;\n}\n.lean-project-textarea .santd-input:focus {\n  box-shadow: none !important;\n}\n.lean-input-cell.lean-input-cell-textarea > .cell-content {\n  min-height: 68px;\n}\n", ""]);

